import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, Collapse, Label } from "reactstrap";
import { Link } from "react-router-dom";
import classname from "classnames";
import withRouter from "../Components/withRouter";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import env from "environment_system/env_system";
import { getAuthData, hasRole } from "utils/auth/authUtils";
import { Roles, VesselTypeConstant } from "shared/constants";
import { RootState } from "index";
import { setCurrentReport, setVesselID, setVesselState } from "Store/Generic/ReportingSlice";

const Navbar = () => {
    /** State variables */
    const { Vessels, VesselID } = useSelector((state: RootState) => state.Reporting);
    const dispatch = useDispatch();
    const vessel = Vessels.find((rec: any) => rec.id === VesselID);
    const leftMenu = useSelector((state: any) => state.Layout.leftMenu);
    const [active, setActive] = useState("");
    const location = useLocation();
    const pathName = location.pathname;
    const assignedVessel = getAuthData("vessels");
    /** State variables end */

    useEffect(() => {
        let matchingMenuItem = null;
        const ul: any = document.getElementById("navigation");
        const items: any = ul.getElementsByTagName("a");
        removeActivation(items);
        for (let i = 0; i < items.length; ++i) {
            if (window.location.href === items[i].href) {
                matchingMenuItem = items[i];
                break;
            }
        }
        if (matchingMenuItem) {
            activateParentDropdown(matchingMenuItem);
        }
    }, [pathName]);


    function activateParentDropdown(item: any) {
        item.classList.add("active");
        const parent = item.closest(".dropdown-menu");
        if (parent) {
            parent.classList.add("active"); // li
            const parent2 = parent.parentElement;
            parent2.classList.add("active"); // li
            const parent3 = parent2.parentElement;
            if (parent3) {
                parent3.classList.add("active"); // li
                const parent4 = parent3.parentElement;
                if (parent4) {
                    parent4.classList.add("active"); // li
                    const parent5 = parent4.parentElement;
                    if (parent5) {
                        parent5.classList.add("active"); // li
                        const parent6 = parent5.parentElement;
                        if (parent6) {
                            parent6.classList.add("active"); // li
                        }
                    }
                }
            }
        }
        return false;
    }

    const removeActivation = (items: any) => {
        for (let i = 0; i < items.length; ++i) {
            let item = items[i];
            const parent = items[i].parentElement;
            if (item && item.classList.contains("active")) {
                item.classList.remove("active");
            }
            if (parent && parent.classList.contains("active")) {
                parent.classList.remove("active");
            }
        }
    };

    const hasLNGCarrierWithDisplay = Vessels.some(
        vessel => vessel.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER && vessel.display === true
    );
    const hasTankerWithDisplay = Vessels.some(
        vessel => (vessel.vessel_type_precedence_id === VesselTypeConstant.TANKER || vessel.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER) && vessel.display === true
    );

    return (
        <React.Fragment>
            <Row className={hasRole(Roles.ES_ADMIN || Roles.MANAGER || Roles.ADMIN) ? 'mb-2' : ''}>
                <div className="topnav">
                    <div className="container-fluid">
                        <nav
                            className="navbar navbar-light navbar-expand-lg topnav-menu"
                            id="navigation"
                        >
                            <Collapse
                                isOpen={leftMenu}
                                className="navbar-collapse"
                                id="topnav-menu-content"
                            >
                                <ul className="navbar-nav">
                                    {(hasRole(Roles.ES_ADMIN) ||
                                        hasRole(Roles.MANAGER) ||
                                        hasRole(Roles.MASTER) ||
                                        hasRole(Roles.CHIEFENGINEER) ||
                                        hasRole(Roles.ADMIN)) && (
                                            <li className="mr-1 nav-item">
                                                <Link
                                                    className={"nav-link p-2 ps-0 mt-1 dropdown-toggle arrow-none dropdown"}
                                                    to="/dashboard"
                                                >
                                                    <span className="font-15">Dashboard</span>
                                                </Link>
                                            </li>
                                        )}
                                    {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MANAGER) || hasRole(Roles.ADMIN)) && (
                                        <li className="mr-1 nav-item dropdown">
                                            <Link
                                                to="/#"
                                                onClick={(e) => e.preventDefault()}
                                                onMouseEnter={(e) => {
                                                    e.preventDefault();
                                                    setActive("fleet");
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.preventDefault();
                                                    setActive("");
                                                }}
                                                className="nav-link p-2 ps-0 mt-1 dropdown-toggle arrow-none"
                                            >
                                                <span className="font-15">Fleet<div className="arrow-down"></div> </span>
                                            </Link>
                                            <div
                                                className={classname(
                                                    "dropdown-menu mega-dropdown-menu dropdown-menu-right dropdown-mega-menu-md",
                                                    { show: active === "fleet" }
                                                )}
                                            >
                                                <div className="ps-2 p-lg-0">
                                                    <Row>
                                                        <Col lg={2}>
                                                            <Link
                                                                className={"dropdown-item"}
                                                                to="/fleet_assessment"
                                                            >
                                                                <span> Fleet  Assessment </span>
                                                            </Link>
                                                            <Link className={"dropdown-item"} to="/fleet_management">
                                                                <span>Fleet Management </span>
                                                            </Link>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </li>
                                    )}
                                    {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MANAGER) || hasRole(Roles.ADMIN)) && (
                                        <li className="mr-1 nav-item dropdown">
                                            <Link
                                                to="/#"
                                                onClick={(e) => e.preventDefault()}
                                                onMouseEnter={(e) => {
                                                    e.preventDefault();
                                                    setActive("analysis");
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.preventDefault();
                                                    setActive("");
                                                }}
                                                className="nav-link p-2 ps-0 mt-1 dropdown-toggle arrow-none"
                                            >
                                                <span className="font-15">Emission Analysis<div className="arrow-down"></div> </span>
                                            </Link>
                                            <div
                                                className={classname(
                                                    "dropdown-menu mega-dropdown-menu dropdown-menu-right dropdown-mega-menu-md",
                                                    { show: active === "analysis" }
                                                )}
                                            >
                                                <div className="ps-2 p-lg-0">
                                                    <Row>
                                                        <Col lg={2}>
                                                            <Link
                                                                className={"dropdown-item"}
                                                                to="/cii_assessment"
                                                            >
                                                                <span> CII Assessment </span>
                                                            </Link>
                                                            <Link className={"dropdown-item"} to="/imo_dcs">
                                                                <span>IMO DCS </span>
                                                            </Link>
                                                            <Link className={"dropdown-item"} to="/eu_mrv_ets">
                                                                <span> EU MRV/ETS </span>
                                                            </Link>
                                                            {/* <Link className={"dropdown-item"} to="/uk_mrv">
                                                                 <span className="font-15">UK MRV</span>
                                                            </Link> */}
                                                            {env?.fuel_eu &&
                                                                <Link className={"dropdown-item"} to="/fuel_eu">
                                                                    <span> FuelEU </span>
                                                                </Link>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </li>
                                    )}
                                    {/* {(hasRole(Roles.ES_ADMIN) ||
                                hasRole(Roles.MANAGER)) &&
                                <li className="width-3 nav-item dropdown">
                                    <Link
                                        className="nav-link p-2 ps-0 mt-1 dropdown-toggle arrow-none"
                                        to="/vessel_performance"
                                    >
                                         <span className="font-15">Vessel Performance</span>
                                    </Link>
                                </li>
                            } */}
                                    {(hasRole(Roles.ES_ADMIN) ||
                                        hasRole(Roles.MANAGER) ||
                                        hasRole(Roles.MASTER) ||
                                        hasRole(Roles.CHIEFENGINEER) ||
                                        hasRole(Roles.ADMIN)) && (
                                            <li className="mr-1 nav-item dropdown">
                                                <Link
                                                    to="/masters/vessel_reporting"
                                                    className={"nav-link p-2 ps-0 mt-1 dropdown-toggle arrow-none"}
                                                    onClick={() => {
                                                        if (hasRole(Roles.MASTER) || hasRole(Roles.CHIEFENGINEER)) {
                                                            dispatch(setVesselID(assignedVessel?.[0] ?? null));
                                                            dispatch(setVesselState("VOYAGE_REPORTING"));
                                                        } else {
                                                            dispatch(setVesselState(null));
                                                            dispatch(setCurrentReport(null));
                                                        }
                                                    }}
                                                >
                                                    <span className="font-15">Vessel Reporting</span>
                                                </Link>
                                            </li>
                                        )}
                                    {(hasRole(Roles.ES_ADMIN)) && (
                                        <li className="mr-1 nav-item dropdown">
                                            <Link
                                                to="/#"
                                                onClick={(e) => e.preventDefault()}
                                                onMouseEnter={(e) => {
                                                    e.preventDefault();
                                                    setActive("adjustments");
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.preventDefault();
                                                    setActive("");
                                                }}
                                                className="nav-link p-2 ps-0 mt-1 dropdown-toggle arrow-none"
                                            >
                                                <span className="font-15">Adjustments<div className="arrow-down"></div></span>
                                            </Link>
                                            <div
                                                className={classname(
                                                    "dropdown-menu mega-dropdown-menu dropdown-menu-right dropdown-mega-menu-md",
                                                    { show: active === "adjustments" }
                                                )}
                                            >
                                                <div className="ps-2 p-lg-0">
                                                    <Row>
                                                        <Col lg={2}>
                                                            <Link
                                                                to="/voyage_adjustment"
                                                                className="dropdown-item"
                                                            >
                                                                <span>Voyage Adjustment</span>
                                                            </Link>
                                                            {hasTankerWithDisplay && (
                                                                <Link
                                                                    to="/sts_adjustment"
                                                                    className="dropdown-item"
                                                                    onClick={() => {
                                                                        if (vessel?.vessel_type_precedence_id !== VesselTypeConstant.TANKER) {
                                                                            dispatch(setVesselID(null))
                                                                        }
                                                                    }}
                                                                >
                                                                    <span> STS Adjustment</span>
                                                                </Link>
                                                            )}
                                                            <Link
                                                                to="/FC(elec+boiler+other)_adjustment"
                                                                className="dropdown-item"
                                                            >
                                                                <span> FC<sub>(elec + boiler + other)</sub></span>
                                                            </Link>
                                                            {hasLNGCarrierWithDisplay && (
                                                                <Link
                                                                    to="/n2_correction"
                                                                    className="dropdown-item"
                                                                    onClick={() => {
                                                                        if (vessel?.vessel_type_precedence_id !== VesselTypeConstant.LNG_CARRIER) {
                                                                            dispatch(setVesselID(null))
                                                                        }
                                                                    }}
                                                                >
                                                                    <span> N<sub>2</sub> Correction</span>
                                                                </Link>
                                                            )}
                                                            {env.inDevelopment && hasRole(Roles.ES_ADMIN) &&
                                                                <Link
                                                                    to="/final_adjustment"
                                                                    className="dropdown-item"
                                                                >
                                                                    <span> Final Adjustment</span>
                                                                </Link>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </li>
                                    )}
                                    {/* {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MANAGER)
                                    || hasRole(Roles.MASTER)
                                    || hasRole(Roles.CHIEFENGINEER)) && (env.desktop_app === true) && (
                                        <li className="width-3 nav-item">
                                            <Link className="nav-link p-2 ps-0 mt-1" to="/sync_report">
                                                SyncReport
                                            </Link>
                                        </li>
                                    )} */}
                                    {/* {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MANAGER)
                                    || hasRole(Roles.MASTER)
                                    || hasRole(Roles.CHIEFENGINEER)) && (
                                        <li className="width-3 nav-item">
                                            <Link className="nav-link p-2 ps-0 mt-1" to="/notifications">
                                                Notification
                                            </Link>
                                        </li>
                                    )} */}
                                    {!(hasRole(Roles.CHIEFENGINEER)) && !env.offlineCopy && (
                                        <li className="mr-1 nav-item dropdown">
                                            <Link
                                                to="/#"
                                                onClick={(e) => e.preventDefault()}
                                                onMouseEnter={(e) => {
                                                    e.preventDefault();
                                                    setActive("other");
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.preventDefault();
                                                    setActive("");
                                                }}
                                                className="nav-link p-2 ps-0 mt-1 dropdown-toggle arrow-none"
                                            >
                                                <span className="font-15">Other<div className="arrow-down" /></span>
                                            </Link>
                                            <div
                                                className={classname(
                                                    "dropdown-menu mega-dropdown-menu dropdown-menu-right dropdown-mega-menu-md",
                                                    { show: active === "other" }
                                                )}
                                            >
                                                <div className="ps-2 p-lg-0">
                                                    <Row>
                                                        <Col lg={2}>
                                                            {(hasRole(Roles.ES_ADMIN)) && (
                                                                <Link className="dropdown-item" to="/users">
                                                                    <span>User Management</span>
                                                                </Link>
                                                            )}
                                                            {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.ADMIN)) && (
                                                                <Link className="dropdown-item" to="/uploaded_files">
                                                                    <span>View  Files</span>
                                                                </Link>
                                                            )}
                                                            {hasRole(Roles.ES_ADMIN) && env.fuel_eu && (
                                                                <Link className="dropdown-item" to="/pooling">
                                                                    <span>Pooling</span>
                                                                </Link>
                                                            )}
                                                            {(hasRole(Roles.ES_ADMIN)) && (
                                                                <Link className="dropdown-item" to="/other_port">
                                                                    <span>Other Port</span>
                                                                </Link>
                                                            )}
                                                            {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.ADMIN)) && (
                                                                <Link className="dropdown-item" to="/off_hire_management">
                                                                    <span>Off Hire Management</span>
                                                                </Link>
                                                            )}
                                                            {(hasRole(Roles.ES_ADMIN)) && (
                                                                <Link className="dropdown-item" to="/vessel_mapping">
                                                                    <span>Vessel Mapping</span>
                                                                </Link>
                                                            )}
                                                            {((hasRole(Roles.ES_ADMIN) || hasRole(Roles.MANAGER) || hasRole(Roles.MASTER))) && !env.offlineCopy &&
                                                                (
                                                                    <Link
                                                                        className="dropdown-item"
                                                                        to="/onboarding"
                                                                        onClick={() => dispatch(setVesselState(null))}
                                                                    >
                                                                        <span>Onboarding</span>
                                                                    </Link>
                                                                )}
                                                            {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.ADMIN)) && (
                                                                <Link className="dropdown-item" to="/rob_data">
                                                                    <span>ROB Data</span>
                                                                </Link>
                                                            )}
                                                            {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.ADMIN) || hasRole(Roles.MANAGER)) && env?.inDevelopment && (
                                                                <Link className="dropdown-item" to="/uploaded_files">
                                                                    <span>View Files</span>
                                                                </Link>
                                                            )}
                                                            {/* Reports Submenu */}
                                                            {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.ADMIN) || hasRole(Roles.MANAGER)) && (
                                                                <div className="dropdown-submenu">
                                                                    <Label className="dropdown-item dropdown-toggle">
                                                                        <i className="bx bx-chevron-left" />Reports
                                                                    </Label>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link to="/custom_company_report" className="dropdown-item">
                                                                            <span>Custom Report</span>
                                                                        </Link>
                                                                        <Link to="/sensor_status" className="dropdown-item">
                                                                            <span>Sensor Status</span>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Simulator Submenu */}
                                                            {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.ADMIN)) && (
                                                                <div className="dropdown-submenu">
                                                                    <Label className="dropdown-item dropdown-toggle">
                                                                        <i className="bx bx-chevron-left" /> Simulator
                                                                    </Label>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link to="/cii_simulator" className="dropdown-item">
                                                                            <span>CII Simulator</span>
                                                                        </Link>
                                                                        {/* Uncomment if needed */}
                                                                        <Link to="/voyage_estimator" className="dropdown-item">
                                                                            Voyage Estimator
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {env?.masters && hasRole(Roles.ES_ADMIN) && (
                                                                <div className="dropdown-submenu">
                                                                    <Label className="dropdown-item dropdown-toggle">
                                                                        <i className="bx bx-chevron-left" /> Masters
                                                                    </Label>
                                                                    <div className="dropdown-menu master-dropdown-menu dropdown-menu-right">
                                                                        <div className="ps-2 p-lg-0">
                                                                            <Row>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/region_master" className="dropdown-item">Region Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/contact_type_master" className="dropdown-item">Contact Type Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/fuel_type_master" className="dropdown-item">Fuel Type Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/fuel_sub_type_master" className="dropdown-item">Fuel Sub Type Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/vessel_type_master" className="dropdown-item">Vessel Type Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/hull_type_master" className="dropdown-item">Hull Type Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/wind_direction_master" className="dropdown-item">Wind Direction Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/vessel_load_condition_master" className="dropdown-item">Load Condition Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/beaufort_scale_master" className="dropdown-item">Beaufort Scale Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/strait_canal_transit_list_master" className="dropdown-item">Strait Canal Transit</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/country_master" className="dropdown-item">Country Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/vessel_owner_details" className="dropdown-item">Vessel Owner Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/fuel_master" className="dropdown-item">Fuel Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/vessel_sub_type_master" className="dropdown-item">Vessel Sub Type Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/port_master" className="dropdown-item">Port Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/cii_adjustment_events_master" className="dropdown-item">CII Adjustment Event Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/machinery_list_master" className="dropdown-item">Machinery List Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/lube_oil_list_master" className="dropdown-item">Lube Oil List Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/current_direction_master" className="dropdown-item">Current Direction Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/douglas_sea_scale_master" className="dropdown-item">Douglas Sea Scale Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/reporting_type_master" className="dropdown-item">Reporting Type Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/reporting_events_master" className="dropdown-item">Reporting Events Master</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/reporting_operation_mode_master" className="dropdown-item">Reporting Operation</Link>
                                                                                </Col>
                                                                                <Col lg={4}>
                                                                                    <Link to="/masters/fuel_class_master" className="dropdown-item">Fuel Class Master</Link>
                                                                                </Col>
                                                                            </Row>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </li>
                                    )}
                                    {(hasRole(Roles.ES_ADMIN)
                                        || hasRole(Roles.MANAGER)
                                        || hasRole(Roles.MASTER)
                                        || hasRole(Roles.CHIEFENGINEER)
                                        || hasRole(Roles.ADMIN)) && env.offlineCopy && (
                                            <li className="mr-1 nav-item dropdown">
                                                <Link
                                                    to="/#"
                                                    onClick={(e) => e.preventDefault()}
                                                    onMouseEnter={(e) => {
                                                        e.preventDefault();
                                                        setActive("about");
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.preventDefault();
                                                        setActive("");
                                                    }}
                                                    className="nav-link p-2 ps-0 mt-1 dropdown-toggle arrow-none"
                                                >
                                                    <span className="font-15">About<div className="arrow-down"></div> </span>
                                                </Link>
                                                <div
                                                    className={classname(
                                                        "dropdown-menu mega-dropdown-menu dropdown-menu-right dropdown-mega-menu-md",
                                                        { show: active === "about" }
                                                    )}
                                                >
                                                    <div className="ps-2 p-lg-0">
                                                        <Row>
                                                            <Col lg={2}>
                                                                <Link
                                                                    className={"dropdown-item"}
                                                                    to="/check_update"
                                                                >
                                                                    <span> Check Update </span>
                                                                </Link>
                                                                <Link className={"dropdown-item"} to="/about">
                                                                    <span>About</span>
                                                                </Link>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </li>
                                        )}
                                </ul>
                            </Collapse>
                        </nav>
                    </div>
                </div>
            </Row>
        </React.Fragment>
    );
};

Navbar.propTypes = {
    leftMenu: PropTypes.any,
    location: PropTypes.any,
    menuOpen: PropTypes.any,
    t: PropTypes.any,
};

export default withRouter(Navbar);
